import { syncSizeAvailability, setupStickyPurchase } from './bh-product-b-ui.js';
const root = document.querySelector('[data-product-b]');
if (root) {
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];
  const data = JSON.parse($('[data-product-data]').textContent);
  const form = $('form');
  const nativeForm = $('product-form-component');
  const quantity = $('input[name="quantity"]');
  const idInput = $('input[name="id"]');
  const groups = $$('[data-option-index]');
  const main = $('[data-main-add]');
  const sticky = $('[data-sticky-add]');
  const labels = data.labels;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:data.currency}).format(cents/100);
  const sizeGroup = groups.find(g => g.dataset.optionName === 'Size');
  const colorGroup = groups.find(g => g.dataset.optionName === 'Color');
  const charts = [];
  const compactGallery = $('[data-compact-gallery]');
  if (compactGallery) {
    const toggle = compactGallery.querySelector('[data-gallery-toggle]');
    const mobile = matchMedia('(max-width: 760px)');
    let expanded = false;
    const updateGallery = () => {
      const showAll = !mobile.matches || expanded;
      compactGallery.dataset.galleryExpanded = String(showAll);
      toggle.hidden = !mobile.matches;
      toggle.setAttribute('aria-expanded', String(showAll));
      toggle.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
    };
    toggle.addEventListener('click', () => {
      expanded = !expanded;
      updateGallery();
    });
    mobile.addEventListener('change', updateGallery);
    compactGallery.dataset.galleryReady = 'true';
    updateGallery();
    const cleanupGallery = event => {
      if (event.detail?.sectionId !== root.dataset.sectionId) return;
      mobile.removeEventListener('change', updateGallery);
      document.removeEventListener('shopify:section:unload', cleanupGallery);
    };
    document.addEventListener('shopify:section:unload', cleanupGallery);
  }
  let busy = false;
  const selected = () => groups.map(g => g.querySelector('input:checked')?.value);
  const variant = () => data.defaultVariant ? data.variants[0] : data.variants.find(v => v.options.every((value,i) => value === selected()[i]));
  const initial = data.variants.find(v => String(v.id) === idInput.value);
  if (!initial) throw new Error('Product B: selected variant was not returned by Shopify.');
  groups.forEach((g,i) => g.querySelectorAll('input').forEach(input => {input.checked = input.value === initial.options[i];}));
  const fit = $('[data-fit-content]');
  const description = $('[data-description]');
  if (fit) {
    const heading = [...description.querySelectorAll('p')].find(p => p.textContent.trim() === 'Fit');
    if (heading) {
      let node = heading.nextSibling;
      while (node) { const next = node.nextSibling; fit.append(node); node = next; }
      heading.remove();
    }
    if (root.hasAttribute('data-one-size') && !fit.querySelector('table')) {
      const paragraphs = [...fit.querySelectorAll('p')];
      const note = $('[data-one-size-note]');
      if (paragraphs.length === 1 && paragraphs[0].textContent.includes('we have not published measurements for this piece')) {
        const original = document.createElement('div');
        original.className = 'b-one-size-original';
        while (fit.firstChild) original.append(fit.firstChild);
        fit.append(original);
        const compact = document.createElement('div');
        compact.className = 'b-one-size-compact';
        compact.append(note.content.cloneNode(true));
        fit.append(compact);
      }
    }
    const shared = $('[data-shared-chart]');
    if (shared) {
      const source = shared.querySelector('table');
      if (!source) throw new Error('Product B: shared size guide chart is missing.');
      const label = document.createElement('p'); label.className = 'b-chart-heading'; label.textContent = labels.main_line;
      fit.prepend(source.cloneNode(true)); fit.prepend(label);
      const note = source.nextElementSibling;
      if (note) fit.append(note.cloneNode(true));
      shared.remove();
    }
    const sizes = [...sizeGroup.querySelectorAll('input')].map(e => e.value);
    const normalize = text => text.replace(/\s+/g,'').toUpperCase();
    for (const source of fit.querySelectorAll('table')) {
      const grid = [...source.rows].map(r => [...r.cells].map(c => c.textContent.trim()));
      const rowBased = sizes.every(s => grid.slice(1).some(row => normalize(row[0]) === normalize(s)));
      const colBased = sizes.every(s => grid[0].slice(1).some(value => normalize(value) === normalize(s)));
      if (grid.length < 2 || grid.some(row => row.length !== grid[0].length) || (!rowBased && !colBased)) {
        root.dataset.chartError = 'true';
        throw new Error('Product B: size chart does not match this product options.');
      }
      const measures = rowBased ? grid[0].slice(1) : grid.slice(1).map(row => row[0]);
      const values = new Map(sizes.map(size => [size,rowBased ? grid.find((row,i) => i>0 && normalize(row[0])===normalize(size)).slice(1) : grid.slice(1).map(row => row[grid[0].findIndex(v => normalize(v)===normalize(size))])]));
      const chart = document.createElement('div'); chart.className = 'b-chart';
      const desktop = document.createElement('div'); desktop.className = 'b-desktop-chart';
      source.before(chart); desktop.append(source); chart.append(desktop);
      const mobile = document.createElement('table'); mobile.className = 'b-mobile-compare';
      const head = mobile.createTHead().insertRow();
      [labels.measure,...sizes].forEach((text,i) => { const th=document.createElement('th'); th.scope='col'; th.textContent=text; if(i) th.dataset.size=text; head.append(th); });
      const body = mobile.createTBody();
      measures.forEach((measure,i) => {const row=body.insertRow(); const th=document.createElement('th'); th.scope='row'; th.textContent=measure; row.append(th); sizes.forEach(size=>{const td=row.insertCell();td.dataset.size=size;td.textContent=values.get(size)[i];});});
      chart.append(mobile);
      const makeCard = size => {
        const card=document.createElement('div'); card.className='b-size-card';card.dataset.cardSize=size;
        const title=document.createElement('h3');title.textContent=`${labels.measurements_for} ${size}`;card.append(title);
        const dl=document.createElement('dl');measures.forEach((text,i)=>{const dt=document.createElement('dt');dt.textContent=text;const dd=document.createElement('dd');dd.textContent=values.get(size)[i];dl.append(dt,dd);});card.append(dl);return card;
      };
      const active=document.createElement('div');active.className='b-mobile-card';
      sizes.forEach(size=>active.append(makeCard(size)));chart.append(active);
      const compare=document.createElement('details');compare.className='b-all-sizes';
      const summary=document.createElement('summary');summary.textContent=labels.compare_sizes;compare.append(summary);
      let compareTable;
      if (root.hasAttribute('data-compact-size-compare') && sizes.length > 4) {
        compareTable=document.createElement('table');compareTable.className='b-compact-size-table';
        const caption=compareTable.createCaption();caption.className='b-visually-hidden';caption.textContent=labels.compare_sizes;
        const header=compareTable.createTHead().insertRow();
        [rowBased ? grid[0][0] : sizeGroup.dataset.optionName,...measures].forEach(text=>{const th=document.createElement('th');th.scope='col';th.textContent=text;header.append(th);});
        const rows=compareTable.createTBody();
        sizes.forEach(size=>{
          const row=rows.insertRow();row.dataset.compareSize=size;
          const th=document.createElement('th');th.scope='row';th.textContent=size;row.append(th);
          values.get(size).forEach(value=>{const td=row.insertCell();td.textContent=value;});
        });
        compare.append(compareTable);
      } else {sizes.forEach(size=>compare.append(makeCard(size)));}
      chart.append(compare);
      if(sizes.length>4) chart.classList.add('b-card-mode');
      charts.push({chart,mobile,active,source,rowBased,sizes,compareTable});
    }
  }
  function sync() {
    const v=variant();
    syncSizeAvailability(groups, data.variants, {soldOut:labels.sold_out, unavailable:labels.unavailable});
    idInput.value=v?.id || '';
    groups.forEach(g=>{const label=g.querySelector('[data-option-label]'); if(label) label.textContent=g.querySelector('input:checked')?.value || '';});
    const color=colorGroup?.querySelector('input:checked');
    const size=sizeGroup?.querySelector('input:checked')?.value;
    if($('[data-size-name]')) $('[data-size-name]').textContent=size || '';
    $('[data-color-caption]').textContent=color?.value || '';
    const image=$('#product-b-main-image');
    const nextImage=color?.dataset.colorImage || v?.featured_image?.src;
    if(nextImage && image.getAttribute('src')!==nextImage){image.removeAttribute('srcset');image.src=nextImage;image.alt=`${$('h1').textContent} · ${color?.value || ''}`;}
    const label=busy?labels.adding:!v?labels.unavailable:v.available?labels.add:labels.sold_out;
    main.disabled=sticky.disabled=busy||!v?.available;
    $('[data-add-label]').textContent=sticky.textContent=label;
    if(v){
      $('[data-price]').textContent=money(v.price);
      const compare=$('[data-compare-price]'); compare.hidden=!(v.compare_at_price>v.price); if(!compare.hidden) compare.textContent=money(v.compare_at_price);
      const saving=$('[data-sale-saving]'); if(saving){saving.hidden=!(v.compare_at_price>v.price); if(!saving.hidden) saving.textContent=labels.sale_saving.replace('__AMOUNT__',money(v.compare_at_price-v.price));}
      $('[data-add-price]').textContent=money(v.price*Number(quantity.value));
      $('[data-sticky-variant]').textContent=data.defaultVariant?$('h1').textContent:v.title;
      $('[data-sticky-quantity]').textContent=`${labels.quantity} ${quantity.value} · ${money(v.price*Number(quantity.value))}`;
      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url);
    } else {$('[data-sticky-variant]').textContent=selected().join(' / ');$('[data-add-price]').textContent='';}
    for(const c of charts){
      c.mobile.querySelectorAll('[data-size]').forEach(cell=>cell.classList.toggle('b-selected',cell.dataset.size===size));
      c.active.querySelectorAll('[data-card-size]').forEach(card=>{card.hidden=card.dataset.cardSize!==size;});
      c.compareTable?.querySelectorAll('[data-compare-size]').forEach(row=>{
        const current=row.dataset.compareSize===size;
        row.classList.toggle('b-selected',current);
        if(current) row.setAttribute('aria-current','true'); else row.removeAttribute('aria-current');
      });
      [...c.source.rows].forEach((row,i)=>[...row.cells].forEach((cell,j)=>{cell.classList.toggle('b-selected',c.rowBased?i>0&&normalizeCell(row.cells[0])===normalizeValue(size):j>0&&normalizeCell(c.source.rows[0].cells[j])===normalizeValue(size));}));
    }
    $('[data-quantity-change="-1"]').disabled=busy||Number(quantity.value)<=1;
    $('[data-quantity-change="1"]').disabled=busy||Number(quantity.value)>=99;
  }
  const normalizeValue = s => (s||'').replace(/\s+/g,'').toUpperCase();
  const normalizeCell = e => normalizeValue(e.textContent.trim());
  function setQuantity(value){quantity.value=String(Math.max(1,Math.min(99,Math.trunc(Number(value))||1)));sync();}
  form.addEventListener('change',e=>{if(busy)return;if(e.target===quantity)setQuantity(quantity.value);sync();$('[data-status]').textContent=`${labels.selected} ${variant()?.title||labels.unavailable}`;});
  quantity.addEventListener('input',()=>{if(quantity.value!=='')setQuantity(quantity.value);});
  quantity.addEventListener('blur',()=>setQuantity(quantity.value));
  $$('[data-quantity-change]').forEach(b=>b.addEventListener('click',()=>setQuantity(Number(quantity.value)+Number(b.dataset.quantityChange))));
  sticky.addEventListener('click',()=>{if(!busy&&!main.disabled)form.requestSubmit(main);});
  $$('[data-view]').forEach(b=>b.addEventListener('click',()=>{const image=$('#product-b-detail-image');image.removeAttribute('srcset');image.src=b.dataset.image;image.alt=b.dataset.alt;$('[data-view-caption]').textContent=b.dataset.shownColor?labels.color_shown.replace('__COLOR__',b.dataset.shownColor):labels.reference_color;$$('[data-view]').forEach(other=>other.setAttribute('aria-pressed',String(other===b)));}));
  nativeForm.addEventListener('bh:cart-add-start',()=>{busy=true;groups.forEach(g=>{g.disabled=true;});quantity.readOnly=true;root.setAttribute('aria-busy','true');sync();});
  nativeForm.addEventListener('bh:cart-add-end',()=>{busy=false;groups.forEach(g=>{g.disabled=false;});quantity.readOnly=false;root.removeAttribute('aria-busy');sync();});
  const resize=new ResizeObserver(()=>{for(const c of charts){if(c.sizes.length<=4&&innerWidth<=760){c.chart.classList.remove('b-card-mode');if([...c.mobile.querySelectorAll('th,td')].some(cell=>cell.scrollWidth>cell.clientWidth+1))c.chart.classList.add('b-card-mode');}}});
  resize.observe(root);
  sync();root.dataset.ready='true';
  setupStickyPurchase(root);
}
